import { Component, computed } from '@angular/core';
import { AppstateService } from 'src/app/services/appstate.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-plangebiete-bar',
  templateUrl: './plangebiete-bar.component.html',
  styleUrl: './plangebiete-bar.component.scss'
})
export class PlangebieteBarComponent {

  public sidenavPadding = computed(() => (this.appStateService.sidenavExpanded() ? '8px 16px 16px 16px' : '8px 12px 16px 12px'))

  constructor(public appStateService: AppstateService,
              public navigationService: NavigationService) {
    
  }

  ngOnInit() {
    
  }

  onClick(value: string) {
    this.appStateService.navigationPlangebiet.set(value);
    if (this.appStateService.sidenavExpanded() == false) {
      this.navigationService.toggleNavigationPanel();
    }
  }

}
